import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import ReactDOM from 'react-dom'
import { connect } from "react-redux";
import { UserRoles } from '../../../constants'
import employeeService from '../../../services/Employee.service'

import CheckImage from '../../../images/check.png';

const Wrapper = styled.nav`
border-bottom: 1px solid #CCCCCC;
width: 100%;
`

const NavigationContainer = styled.ul`
width: 960px;
margin: 0 auto;
padding: 0;
height: 43px;
list-style: none;
background-color: white;


@media (max-width: 768px) {
  height: auto;
  padding: 0;
  width: 100%;
  border-bottom: none;
}

> li {
  float: left;
  height: 43px;

  @media (max-width: 768px) {
    float: none;
    clear: both;
    width: 100%;
  }
}

> li > a {
  text-decoration: none;
  font-family: Lato-Light;
  font-size: 18px;
  color: #4D4D4D;
  line-height: 20px;
  float: left;
  padding: 11px 15px 11px 15px;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-bottom-color: transparent;

  @media (max-width: 768px) {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    float: none;
    display: block;
    border-bottom-width: 1px;
    border-bottom-color: #DDDDDD;
  }
}
> li > a.active {
  color: #11959A;
  border-bottom-color: #00B550;

  @media (max-width: 768px) {
    color: #2B2B2B;
    border-bottom-color: #DDDDDD;
    background-image: url(${CheckImage});
    background-repeat: no-repeat;
    background-position: 190px 13px;
  }
}
`

export class Navigation extends Component {

  componentDidMount() {
    const domNode = ReactDOM.findDOMNode(this);
    var menubarNode = domNode.querySelectorAll('ul[role=menubar]');
    var menubar = new window.Menubar(menubarNode[0]);
    menubar.init();
  }

  onNavLinkClicked = () => {
    if (this.props.callbackParent != null) {
      this.props.callbackParent();
    }
  }

  render() {
    const { t, employee } = this.props
    return (
      <Wrapper className="nav-wrapper">
        <NavigationContainer role="menubar" aria-label={t('Navigation.Label')}>
          <li>
            <NavLink role="menuitem"
              tabIndex="0"
              aria-haspopup={false}
              to="/dashboard" id="dashboard_route" className="at-glance-link" onClick={this.onNavLinkClicked}>
              {t('Navigation.AtAGlanceLabel')}
            </NavLink>
          </li>
          <li>
            <NavLink role="menuitem"
              tabIndex="-1"
              aria-haspopup={false}
              to="/stock-awards" id="awards_route" className="stock-awards-link" onClick={this.onNavLinkClicked}>
              {t('Navigation.StockAwardLabel')}
            </NavLink>
          </li>
          {!employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE) && employeeService.showAvailableBrokers(employee) &&
            <li>
              <NavLink role="menuitem"
                tabIndex="-1"
                aria-haspopup={false}
                to="/broker" id="broker_route" className="available-brokers-link" onClick={this.onNavLinkClicked}>
                {t('Navigation.BrokerLabel')}
              </NavLink>
            </li>
          }
          {!employeeService.isWholeFoodsEmployee(employee) &&
            <li>
              <NavLink role="menuitem"
                tabIndex="-1"
                aria-haspopup={false}
                to="/more-about-stock" id="more_route" className="more-about-stock-link" onClick={this.onNavLinkClicked}>
                {t('Navigation.FAQLabel')}
              </NavLink>
            </li>
          }
        </NavigationContainer>
      </Wrapper>
    )
  }
}


const mapState = state => ({
  employee: state.employee
});


export default withRouter(connect(mapState, null)(withTranslation('translations')(Navigation)));


